export const CLICK = {
    EVENT_TYPE: 'clicked_on_tailored_home_page_component',
    ACTION_TYPE: 'click',
    EVENT_SOURCE: 'tailored_home_page',
    SUB_GROUP: 'tailored_home_page',
    PAGE_NAME: 'tailored_homepage',
};
